export default "__VITE_ASSET__CL2wd$wv__"